import { DeliveryRoute, SettingResponse } from '@apiContract';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import path from 'lodash/fp/path';

export const getRoutesList = (routes: DeliveryRoute[] | null | undefined) => {
  if (!routes || routes.length === 0) {
    return '';
  }
  return routes.map((route) => route.name).join(', ') + ' / ';
};

export const BEErrorsToRHF = (errors?: FetchBaseQueryError) => {
  const data = errors?.data as SettingResponse;
  const init: { [key: string]: { message: string | undefined } } = {};
  return Object.keys(data?.validationResult?.errors || {}).reduce((acc, key) => {
    acc[key] = { message: data?.validationResult?.errors?.[key][0] };
    return acc;
  }, init);
};

export const mapProps = (resultKeys: string[], sourceList: any[], obj: any) =>
  resultKeys.reduce<any>((acc, item, key) => {
    const nextGet = sourceList[key];
    if (nextGet) {
      const nextValue = typeof nextGet === 'string' ? path(nextGet, obj) : nextGet(obj);
      if (nextValue !== undefined) {
        acc[item] = nextValue;
      }
    }

    return acc;
  }, {});
